firebird.factory('meetingService', [
    '$rootScope',
    'cookieService',
    'helperService',
    'routerService',
    'socketService',
    'automationService',
    'logService',
    '$window',
    'attendeeService',
    'analyticsWrapperService',
    'localizationService',
    'brandingService',
    'configService',
    'storageService',
    'meetingStateService',
    'meetingUpgradedService',
    'subscriptionService',
    'waitingRoomStateService',
    function (
        $rootScope,
        cookieService,
        helperService,
        routerService,
        socketService,
        automationService,
        logService,
        $window,
        attendeeService,
        analyticsWrapperService,
        localizationService,
        brandingService,
        configService,
        storageService,
        meetingStateService,
        meetingUpgradedService,
        subscriptionService,
        waitingRoomStateService
    ) {
        const logger = new LogServiceWrapper(logService, 'meetingService');

        let meeting = {},
            meetingCode = '',
            date,
            startTime,
            endTime,
            upcomingEventTimes,
            title = '',
            phoneNumber,
            attendeePIN,
            presenterPIN,
            meetingServer,
            timeZone = '',
            timeZoneId = '',
            brandingInformation,
            featureList,
            joinAudioMuted = false,
            joinAudioMutedInitialized = false,
            locked = false,
            joinRequests = [],
            allowJoinRequests = false,
            allowJoinBeforeHost = false,
            joinBeforeHostEnabled = false,
            recordScreenshareOnly = false,
            lockedInitialized = false,
            shouldShowUnlockMeetingNotification = false,
            isWaitingForLockUpdate = false,
            e2eeMaxUsers = 0,
            inQAMode = false,
            isOnAir = false,
            parentMeetingAccessCode = null,
            exitUrl,
            requiresPassword = false,
            appLogoURL = 'img/logos/horizontal.png',
            poweredBy = '',
            supportURL = '',
            companyName = '',
            resellerId = '',
            //done to give alert in the header controller

            virtualBackgroundEnabled = false,
            securitySettingChange = false,
            betaSettingChecked = false,
            denoiseValue = '',
            autoVolumeAdjustment = true,
            echoDetectionEnabled = false,
            autoEchoDetectionEnabled = false,
            echoDetectionFeatureEnabled = false,
            hostNotificationCulture = '',
            meetingCryptoKeySalt = null,
            preventRerouting = false,
            hasTranscription = false,
            meetingSecuritySettingsEnabled = false,
            calendarTimerInfo = null,
            audioNacks = false,
            deviceSelectionEnabled = false,
            verticalJoinFlowEnabled = false,
            defaultOSDeviceEnabled = false,
            hasShownDeviceSelectionModal = false,
            vaLanguageSelectionEnabled = false,
            meetingReactionsOn = true,
            meetingLockAudioPromptsEnabled = false,
            isWebinarVirtualBlurredBackgroundAvailable = false,
            enableAutoPerformanceMode = false,
            meetingPrivateChatEnabled = false,
            e2eeAvailable = false,
            e2eeEstablished = false,
            notesRecipients = 'all',
            enableOracleLiveChat = false,
            enableCopyFirepadText = false,
            enableMarqueeButtonHide = false,
            enableAudioDisconnect = true,
            webinarOptions = {
                showAttendeeList: false,
                showPublicChat: true,
                privateChatOnly: true,
                enableChimes: false,
                lockWebinar: false,
                showReactionsAnimation: false
            },
            meetingTypes = {
                STANDARD: 1,
                PHONE_CONFERENCE: 2,
                WEBINAR: 3,
                VIDEO_CONFERENCE: 4,
                SCREEN_SHARE: 5
            },
            rootSubscription,
            // these parameters are being handled by angular subscriptions
            meetingTypeID,
            sfuEnabled,
            meetingSecuritySettings,
            maxUsers,
            attendeeFavoritesEnabled,
            localizedMeetingType,
            meetingTypeName,
            hasQualityBars,
            service = {
                init: init,
                openExternalLink: openExternalLink,
                redirectAfterMeeting: redirectAfterMeeting,
                endMeeting: endMeeting,
                disconnectKickedAttendeeFromMeeting: disconnectKickedAttendeeFromMeeting,
                getCurrentMeeting: getCurrentMeeting,
                getDate: getDate,
                getStartTime: getStartTime,
                getEndTime: getEndTime,
                getUpcomingEventTimes: getUpcomingEventTimes,
                setTitle: setTitle,
                getTitle: getTitle,
                getMeetingCode: getMeetingCode,
                getMeetingServer: getMeetingServer,
                initPhone: initPhone,
                getTimeZone: getTimeZone,
                getTimeZoneId: getTimeZoneId,
                setBrandingInfo: setBrandingInfo,
                getBrandingInfo: getBrandingInfo,
                getBrandingLogoUrl: getBrandingLogoUrl,
                getBrandingBackgroundUrl: getBrandingBackgroundUrl,
                _onBrandingInformation: _onBrandingInformation,
                setFeatureList: setFeatureList,
                getFeatureList: getFeatureList,
                hasFeature: hasFeature,
                hasFeatureList: hasFeatureList,
                hasTranscriptionEnabled: hasTranscriptionEnabled,
                getMeetingSecuritySettings: getMeetingSecuritySettings,
                getMeetingSecuritySettingsEnabled: getMeetingSecuritySettingsEnabled,
                isAllowedByHostSecuritySettings: isAllowedByHostSecuritySettings,
                retrieveMeetingSecuritySettings: retrieveMeetingSecuritySettings,
                retrieveMeetingSecuritySettingsEnabled: retrieveMeetingSecuritySettingsEnabled,
                defaultSecuritySettingsChange: defaultSecuritySettingsChange,
                defaultBetaSettingsChange: defaultBetaSettingsChange,
                getSecuritySettingsChanged: getSecuritySettingsChanged,
                setSecuritySettingsChanged: setSecuritySettingsChanged,
                getBetaSettingsChanged: getBetaSettingsChanged,
                setBetaSettingsChanged: setBetaSettingsChanged,
                securityAndBetaSettingNotifications: securityAndBetaSettingNotifications,
                getMaxUsers: getMaxUsers,
                setE2EEMaxUsers: setE2EEMaxUsers,
                getE2EEMaxUsers: getE2EEMaxUsers,
                getMeetingType: getMeetingType,
                getLocalizedMeetingType: getLocalizedMeetingType,
                isWebinar: isWebinar,
                isWebinarAttendeeListAllowed: isWebinarAttendeeListAllowed,
                isAttendeeListVisibleToAttendees: isAttendeeListVisibleToAttendees,
                isMeeting: isMeeting,
                isWebinarAttendee: isWebinarAttendee,
                isWebinarPresenter: isWebinarPresenter,
                setIsOnAir: setIsOnAir,
                getIsOnAir: getIsOnAir,
                getWebinarOptions: getWebinarOptions,
                setWebinarOptions: setWebinarOptions,
                getExitUrl: getExitUrl,
                getRequiresPassword: getRequiresPassword,
                setJoinAudioMuted: setJoinAudioMuted,
                getJoinAudioMuted: getJoinAudioMuted,
                isJoinAudioMutedInitialized: isJoinAudioMutedInitialized,
                getLocked: getLocked,
                getAllowJoinRequests: getAllowJoinRequests,
                setAllowJoinRequests: setAllowJoinRequests,
                getJoinRequests: getJoinRequests,
                resetJoinRequests: resetJoinRequests,
                declineJoinRequest: declineJoinRequest,
                acceptJoinRequest: acceptJoinRequest,
                playKnockSoundForHost: playKnockSoundForHost,
                isLockedInitialized: isLockedInitialized,
                setIsWaitingForLockUpdate: setIsWaitingForLockUpdate,
                getIsWaitingForLockUpdate: getIsWaitingForLockUpdate,
                shouldShowUnlockNotification: shouldShowUnlockNotification,
                getAppLogoURL: getAppLogoURL,
                getPoweredByName: getPoweredByName,
                getBaseUrl: getBaseUrl,
                getCompanyName: getCompanyName,
                isIntermediaDirectUser: isIntermediaDirectUser,
                isIntermediaPLRUser: isIntermediaPLRUser,
                isUnivergeUser: isUnivergeUser,
                setPreventRerouting: setPreventRerouting,
                setIsSfuEnabled: setIsSfuEnabled,
                getIsSfuEnabled: getIsSfuEnabled,
                setAudioNacks: setAudioNacks,
                getAudioNacks: getAudioNacks,
                setCalendarTimerInfo: setCalendarTimerInfo,
                getCalendarTimerInfo: getCalendarTimerInfo,
                getMeetingLoginUrl: getMeetingLoginUrl,
                getAttendeeLoginUrl: getAttendeeLoginUrl,
                setAttendeeLoginUrl: setAttendeeLoginUrl,
                setDeviceSelectionEnabled: setDeviceSelectionEnabled,
                getDeviceSelectionEnabled: getDeviceSelectionEnabled,
                setVerticalJoinFlowEnabled: setVerticalJoinFlowEnabled,
                getVerticalJoinFlowEnabled: getVerticalJoinFlowEnabled,
                setDefaultOSDeviceEnabled: setDefaultOSDeviceEnabled,
                getDefaultOSDeviceEnabled: getDefaultOSDeviceEnabled,
                shouldShowDeviceSelectionPreview: shouldShowDeviceSelectionPreview,
                isDevicePreviewCacheDetected: isDevicePreviewCacheDetected,
                setHasShownDeviceSelectionModal: setHasShownDeviceSelectionModal,
                getHasShownDeviceSelectionModal: getHasShownDeviceSelectionModal,

                getMeetingReactionsOn: getMeetingReactionsOn,
                setMeetingReactionsOn: setMeetingReactionsOn,

                getMeetingLockAudioPromptsEnabled: getMeetingLockAudioPromptsEnabled,
                setMeetingLockAudioPromptsEnabled: setMeetingLockAudioPromptsEnabled,

                shouldShowCurrentTalker: shouldShowCurrentTalker,

                meetingTypes: meetingTypes,

                setAttendeeFavoritesEnabled: setAttendeeFavoritesEnabled,
                getAttendeeFavoritesEnabled: getAttendeeFavoritesEnabled,

                getLayoutLockEnabled: getLayoutLockEnabled,

                getIsPractice: getIsPractice,
                getParentMeetingAccessCode: getParentMeetingAccessCode,
                setParentMeetingAccessCode: setParentMeetingAccessCode,

                setVirtualBackgroundEnabled: setVirtualBackgroundEnabled,
                getVirtualBackgroundEnabled: getVirtualBackgroundEnabled,

                setEnableAutoPerformanceMode: setEnableAutoPerformanceMode,
                getEnableAutoPerformanceMode: getEnableAutoPerformanceMode,

                getCompactModeAvailable: getCompactModeAvailable,
                getCompactModeAvailableForRestyling: getCompactModeAvailableForRestyling,

                setEnableOracleLiveChat: setEnableOracleLiveChat,
                getEnableOracleLiveChat: getEnableOracleLiveChat,

                setEnableMarqueeButtonHide: setEnableMarqueeButtonHide,
                getEnableMarqueeButtonHide: getEnableMarqueeButtonHide,

                setEnableCopyFirepadText: setEnableCopyFirepadText,
                getEnableCopyFirepadText: getEnableCopyFirepadText,

                isTitleBarAvailable: isTitleBarAvailable,

                setIsWebinarVirtualBlurredBackgroundAvailable: setIsWebinarVirtualBlurredBackgroundAvailable,
                getIsWebinarVirtualBlurredBackgroundAvailable: getIsWebinarVirtualBlurredBackgroundAvailable,

                canUseMeetingChat: canUseMeetingChat,
                canUseMeetingNotes: canUseMeetingNotes,

                getDenoiseValue: getDenoiseValue,
                setDenoiseValue: setDenoiseValue,
                setAutoVolumeAdjustment: setAutoVolumeAdjustment,
                getAutoVolumeAdjustment: getAutoVolumeAdjustment,

                getEchoDetectionEnabled: getEchoDetectionEnabled,
                getHostNotificationCulture: getHostNotificationCulture,
                setHostNotificationCulture: setHostNotificationCulture,
                getEchoDetectionState: getEchoDetectionState,
                setEchoDetectionState: setEchoDetectionState,
                getAutoEchoDetectionState: getAutoEchoDetectionState,
                setAutoEchoDetectionState: setAutoEchoDetectionState,

                setMeetingCryptoKeySaltValue: setMeetingCryptoKeySaltValue,
                getMeetingCryptoKeySaltValue: getMeetingCryptoKeySaltValue,

                canUseMeetingPrivateChat: canUseMeetingPrivateChat,
                setMeetingPrivateChatEnabled: setMeetingPrivateChatEnabled,
                getMeetingPrivateChatEnabled: getMeetingPrivateChatEnabled,

                updateMeetingSecuritySettings: updateMeetingSecuritySettings,
                e2eeEnabled: e2eeEnabled,
                setE2EEAvailable: setE2EEAvailable,
                getE2EEAvailable: getE2EEAvailable,
                setE2EEEstablished: setE2EEEstablished,
                getE2EEEstablished: getE2EEEstablished,
                setNotesRecipients: setNotesRecipients,
                getNotesRecipients: getNotesRecipients,

                setEnableAudioDisconnect: setEnableAudioDisconnect,
                getEnableAudioDisconnect: getEnableAudioDisconnect,
                getJoinBeforeHostEnabled: getJoinBeforeHostEnabled,
                setJoinBeforeHostEnabled: setJoinBeforeHostEnabled,

                getRecordScreenshareOnly: getRecordScreenshareOnly,
                setRecordScreenshareOnly: setRecordScreenshareOnly,

                // function based on new angular
                getMeetingTypeID: getMeetingTypeID,

                getHasQualityBars: getHasQualityBars,
                setHasQualityBars: setHasQualityBars
            };

        initSubscriptions();

        $rootScope.$on('branding-information', _onBrandingInformation);
        $rootScope.$on('feature-list', onFeatureList);
        $rootScope.$on('on-air-mode-updated', onOnAirModeUpdated);
        $rootScope.$on('webinar-options-updated', onWebinarOptionsUpdated);
        $rootScope.$on('join-audio-muted-updated', onJoinAudioMutedUpdated);
        $rootScope.$on('meeting-locked-updated', onMeetingLockedUpdated);
        $rootScope.$on('meeting-title-updated', onMeetingTitleUpdated);
        $rootScope.$on('join-request', onJoinRequest);
        $rootScope.$on('join-request-avatar', onJoinRequestAvatar);
        $rootScope.$on('join-request-updated', onJoinRequestUpdated);
        $rootScope.$on('join-request-canceled', onJoinRequestCanceled);

        $rootScope.$on('node-connected', onNodeConnected);
        $rootScope.$on('node-reconnected', onNodeReconnected);
        $rootScope.$on('transcription-enabled', onTranscriptionEnabled);
        $rootScope.$on('videoroom-pin-updated', onVideoRoomPinUpdated);
        $rootScope.$on('security-settings-updated', onSecuritySettingsUpdated);
        $rootScope.$on('security-settings-enabled', onSecuritySettingsEnabled);
        $rootScope.$on('notify-of-security-change', _showMeetingSecuritySettingChangeAlert);
        $rootScope.$on('meetingReactionsOn-updated', onMeetingReactionsOnUpdated);
        $rootScope.$on('meetingLockAudioPromptsEnabled-updated', onMeetingLockAudioPromptsEnabledUpdated);
        $rootScope.$on('$destroy', onScopeDestroyed);

        return service;

        ////////////////////////

        function _onBrandingInformation(evt, brandingInfo) {
            service.setBrandingInfo(brandingInfo);
        }

        function onNodeConnected() {
            getTranscriptionEnabled();
            retrieveMeetingSecuritySettingsEnabled();
            retrieveMeetingSecuritySettings();
        }

        function onNodeReconnected() {
            getTranscriptionEnabled();
            retrieveMeetingSecuritySettingsEnabled();
            retrieveMeetingSecuritySettings();
        }

        function setCalendarTimerInfo(calendar) {
            if (calendar.startTime && calendar.endTime && calendar.currentTime) {
                logService.log('setting calendar timer info');
                calendarTimerInfo = {
                    startTime: new Date(calendar.startTime),
                    endTime: new Date(calendar.endTime),
                    currentTime: new Date(calendar.currentTime)
                };
            } else {
                logService.log('missing properties on calendar timer info');
            }
        }

        function getCalendarTimerInfo() {
            return calendarTimerInfo;
        }

        function getMeetingLoginUrl() {
            return attendeeService.getIsPresenter() ? meeting.hostLoginUrl : meeting.attendeeLoginUrl;
        }

        function getAttendeeLoginUrl() {
            return meeting.attendeeLoginUrl;
        }

        function setAttendeeLoginUrl(attendeeLoginUrl) {
            meeting.attendeeLoginUrl = attendeeLoginUrl;
            meetingStateService.attendeeLoginUrl = attendeeLoginUrl;
        }

        function getTranscriptionEnabled() {
            var msg = {};
            msg.message = 'transcription-enabled';
            msg.callback = function (result) {
                logService.log('getTranscriptionEnabled result from meeting server', result);
                if (result && result.enabled) {
                    hasTranscription = true;
                }
            };
            socketService.send(msg);
        }

        function onTranscriptionEnabled(e, data) {
            if (data && data.enabled) {
                hasTranscription = true;
            }
        }

        function _showMeetingSecuritySettingChangeAlert() {
            const meetingSecuritySettings = service.getMeetingSecuritySettings();
            if (
                (meetingSecuritySettings.canUnmuteAudio !== false ||
                    meetingSecuritySettings.ignoreCanUnmuteAudio === true) &&
                meetingSecuritySettings.canUnmuteWebcam !== false &&
                meetingSecuritySettings.canShareScreenOrVideo !== false &&
                meetingSecuritySettings.canUseMeetingChat !== false &&
                meetingSecuritySettings.canUseMeetingNotes !== false
            ) {
                // Nothing to display
                return;
            }

            // The meeting host has limited your permissions
            var promptTitle = localizationService.translate(
                'SECURITY_SETTINGS.NOTIFICATION.HOST_LIMITED_YOUR_PERMISSIONS'
            );

            // You are not be able to do the following during this meeting:
            var promptMsg = localizationService.translate(
                'SECURITY_SETTINGS.NOTIFICATION.NOT_ABLE_TO_DO_THE_FOLLOWING'
            );

            promptMsg += '<br/><ul>';

            if (
                meetingSecuritySettings.canUnmuteAudio === false &&
                meetingSecuritySettings.ignoreCanUnmuteAudio === false
            ) {
                // Unmute your microphone
                promptMsg +=
                    '<li>' + localizationService.translate('SECURITY_SETTINGS.NOTIFICATION.UNMUTE_YOUR_MIC') + '</li>';
            }

            if (meetingSecuritySettings.canUnmuteWebcam === false) {
                // Share your webcam
                promptMsg +=
                    '<li>' +
                    localizationService.translate('SECURITY_SETTINGS.NOTIFICATION.SHARE_YOUR_WEBCAM') +
                    '</li>';
            }

            if (meetingSecuritySettings.canShareScreenOrVideo === false) {
                // Share your screen or video
                promptMsg +=
                    '<li>' +
                    localizationService.translate('SECURITY_SETTINGS.NOTIFICATION.SHARE_YOUR_SCREEN') +
                    '</li>';
            }

            if (meetingSecuritySettings.canUseMeetingChat === false) {
                // Can use meeting chat
                promptMsg += '<li>' + localizationService.translate('SECURITY_SETTINGS.USE_MEETING_CHAT') + '</li>';
            }

            if (meetingSecuritySettings.canUseMeetingNotes === false) {
                promptMsg += '<li>' + localizationService.translate('SECURITY_SETTINGS.USE_MEETING_NOTES') + '</li>';
            }

            promptMsg += '</ul>';

            var closeButtonHtml =
                '<button class="sweetalert-close-x" onclick="window.swal.close();" tabindex="3"><img src="img/redesign/icons/close-big.svg"></img></button>';
            $window.swal({
                title: closeButtonHtml + promptTitle,
                text: promptMsg,
                showCancelButton: false,
                showConfirmButton: true,
                confirmButtonColor: brandingService.getBaseColor(),
                confirmButtonText: localizationService.translate('COMMON.CLOSE_TEXT'),
                allowOutsideClick: false,
                html: true,
                imageUrl: 'img/redesign/modal/info.svg',
                customClass: 'security-notification-modal'
            });
        }

        function setSecuritySettingsChanged(value) {
            securitySettingChange = value;
        }

        function getSecuritySettingsChanged() {
            return securitySettingChange;
        }

        function setBetaSettingsChanged(value) {
            betaSettingChecked = value;
        }

        function getBetaSettingsChanged() {
            return betaSettingChecked;
        }

        //Determines if there are beta settings that have been checked might need to be updated as we add other beta features
        function defaultBetaSettingsChange() {
            var blurredBackground = storageService.get('videoFilter');
            //Checks to see whether a beta setting has been checked
            if (blurredBackground === 'blur-bg') {
                setBetaSettingsChanged(true);
            } else {
                setBetaSettingsChanged(false);
            }
        }

        //This determines if there are any unchecked security settings
        function defaultSecuritySettingsChange(newSecuritySettings) {
            var atLeastOneSettingChanged =
                newSecuritySettings.canUnmuteAudio === false ||
                newSecuritySettings.ignoreCanUnmuteAudio === true ||
                newSecuritySettings.canUnmuteWebcam === false ||
                newSecuritySettings.canShareScreenOrVideo === false ||
                newSecuritySettings.canMuteOthers === false ||
                newSecuritySettings.canUseMeetingChat === false ||
                newSecuritySettings.canUseMeetingNotes === false;

            //If the user is the host and there is an unchecked setting
            if (atLeastOneSettingChanged) {
                setSecuritySettingsChanged(true);
                //Security settings are all checked
            } else {
                setSecuritySettingsChanged(false);
            }
        }

        //This is called in the headerCtrl so there they determine which Notification to show
        //For settings that are different than the default Beta and Security
        function securityAndBetaSettingNotifications() {
            defaultBetaSettingsChange();
            var alertNotificationStatusForSecurityAndBetaSettings = {
                betaValueChecked: getBetaSettingsChanged(),
                securitySettingUnchecked: getSecuritySettingsChanged()
            };

            return alertNotificationStatusForSecurityAndBetaSettings;
        }

        function updateMeetingSecuritySettings(newSecuritySettings) {
            var couldInitiallyUsePrivateChat = service.canUseMeetingPrivateChat();
            const oldMeetingSecuritySettings = service.getMeetingSecuritySettings();
            if (newSecuritySettings && newSecuritySettings !== '') {
                // Only use the settings already defined in meetingSecuritySettings
                for (var setting in oldMeetingSecuritySettings) {
                    if (newSecuritySettings.hasOwnProperty(setting)) {
                        oldMeetingSecuritySettings[setting] = newSecuritySettings[setting];
                    }
                }

                meetingStateService.meetingSecuritySettings = oldMeetingSecuritySettings;
                $rootScope.$broadcast('security-settings-changed', oldMeetingSecuritySettings);
            }

            if (oldMeetingSecuritySettings.canShareScreenOrVideo === false) {
                $rootScope.$broadcast('hide-modal', 'electronScreen');
            }

            if (!canUseMeetingChat()) {
                $rootScope.$broadcast('meeting-chat-disabled');
                $rootScope.$broadcast('cleared-meeting-chat-messages');
            }

            if (oldMeetingSecuritySettings.canUseMeetingNotes === false) {
                $rootScope.$broadcast('meeting-notes-disabled');
            }

            if (!service.canUseMeetingPrivateChat() && couldInitiallyUsePrivateChat) {
                $rootScope.$broadcast('meeting-private-chat-disabled');
            }

            $rootScope.$broadcast('theme-state-changed', oldMeetingSecuritySettings.canUseTheme);

            defaultSecuritySettingsChange(oldMeetingSecuritySettings);
        }

        function onSecuritySettingsUpdated(e, newSecuritySettings) {
            service.updateMeetingSecuritySettings(newSecuritySettings);
        }

        function onSecuritySettingsEnabled(e, isEnabled) {
            if (isEnabled === true || isEnabled === false) {
                meetingSecuritySettingsEnabled = isEnabled;
            }
        }

        // Update mobile team if this is changed
        function retrieveMeetingSecuritySettings() {
            var msg = {};
            msg.message = 'retrieve-meeting-security-settings';
            msg.callback = function (result) {
                logService.log('retrieveMeetingSecuritySettings result from meeting server', result);

                service.updateMeetingSecuritySettings(result);
                defaultSecuritySettingsChange(result);
            };
            socketService.send(msg);
        }

        // Update mobile team if this is changed
        function retrieveMeetingSecuritySettingsEnabled() {
            var msg = {};
            msg.message = 'retrieve-meeting-security-settings-enabled';
            msg.callback = function (result) {
                logService.log('retrieveMeetingSecuritySettingsEnabled result from meeting server', result);

                meetingSecuritySettingsEnabled = result === true;
            };
            socketService.send(msg);
        }

        function onMeetingReactionsOnUpdated(e, newMeetingReactionsOn) {
            service.setMeetingReactionsOn(newMeetingReactionsOn);
        }

        function onMeetingLockAudioPromptsEnabledUpdated(e, newMeetingLockAudioPromptsEnabled) {
            service.setMeetingLockAudioPromptsEnabled(newMeetingLockAudioPromptsEnabled);
        }

        function onFeatureList(evt, newFeatureList) {
            logService.log('Received Feature List:', newFeatureList);
            featureList = newFeatureList;
        }

        function setFeatureList(features) {
            featureList = features;
        }

        function getFeatureList() {
            return featureList || {};
        }

        function hasFeature(feature) {
            if (featureList) {
                return featureList[feature] === 'enabled';
            }
            return false;
        }

        function hasFeatureList() {
            return featureList ? true : false;
        }

        function hasTranscriptionEnabled() {
            return hasTranscription;
        }

        function getMeetingSecuritySettings() {
            return Object.assign({}, meetingSecuritySettings);
        }

        function getMeetingSecuritySettingsEnabled() {
            return meetingSecuritySettingsEnabled;
        }

        // extracted in meeting.service.ts
        function isAllowedByHostSecuritySettings(securitySetting) {
            const meetingSecuritySettings = service.getMeetingSecuritySettings();
            if (attendeeService.getIsAttendee() === true && meetingSecuritySettings[securitySetting] === false) {
                return securitySetting === 'canUnmuteAudio' && meetingSecuritySettings.ignoreCanUnmuteAudio === true;
            } else {
                return true;
            }
        }

        function isWebinarAttendee() {
            return service.isWebinar() && attendeeService.getIsAttendee();
        }

        function isWebinarPresenter() {
            return service.isWebinar() && attendeeService.getIsPresenter();
        }

        function init(newMeeting) {
            meeting = newMeeting;

            automationService.setMeetingInfo(newMeeting);

            title = newMeeting.title;
            date = newMeeting.startDate;
            startTime = newMeeting.startTime;
            endTime = newMeeting.endTime;
            timeZone = newMeeting.timeZone;
            timeZoneId = newMeeting.timeZoneId;
            meetingCode = newMeeting.meetingCode;
            meetingServer = newMeeting.meetingServerURI;
            meetingStateService.maxUsers = newMeeting.maxUser;
            meetingStateService.meetingTypeId = newMeeting.meetingType;
            exitUrl = newMeeting.exitUrl;
            requiresPassword = newMeeting.requiresPassword;
            upcomingEventTimes = newMeeting.upcomingEventTimes;
            resellerId = newMeeting.resellerId;
            locked = newMeeting.locked;
            lockedInitialized = true;
            allowJoinRequests = newMeeting.allowJoinRequests;
            allowJoinBeforeHost = newMeeting.allowJoinBeforeHost;

            companyName = brandingService.getCamaroAppName();

            if (newMeeting.appLogoURL) {
                appLogoURL = newMeeting.appLogoURL;
            }

            if (newMeeting.poweredBy) {
                poweredBy = newMeeting.poweredBy;
            }

            if (newMeeting.supportURL) {
                supportURL = newMeeting.supportURL;
            }

            if (newMeeting.echoDetectionEnabled) {
                echoDetectionFeatureEnabled = newMeeting.echoDetectionEnabled;
            }
        }

        function getBaseUrl() {
            return supportURL;
        }

        function getAppLogoURL() {
            if (appLogoURL && appLogoURL.indexOf('cloudfront.net') > -1) {
                return appLogoURL;
            } else {
                if (helperService.getIsRedesign()) {
                    return brandingService.getAppLogo();
                } else {
                    switch (brandingService.getResellerCode()) {
                        case 'plr':
                            return 'img/logos/plr_logo.svg';
                        case 'univergeblue':
                            return service.isWebinar() ? 'img/logos/ub_logo.png' : 'img/logos/ub_logo.svg';
                        default:
                            return 'img/logos/im_logo.svg';
                    }
                }
            }
        }

        function getPoweredByName() {
            return poweredBy || service.getCompanyName();
        }

        //TODO: this isn't implemented anywhere.  Also this function is initialized with meeting info
        //so, likely that info should be populated there and only available here via the getter.
        //in short, don't re-implement this without reading the above two lines
        //        function setCompanyName(newCompanyName) {
        //            companyName = newCompanyName;
        //        }

        function getCompanyName() {
            return companyName || '';
        }

        function setBrandingInfo(newBrandingInfo) {
            brandingInformation = newBrandingInfo;
            $rootScope.$broadcast('branding-info-updated');
        }

        function getBrandingInfo() {
            return brandingInformation || {};
        }

        function getBrandingLogoUrl() {
            if (brandingInformation && brandingInformation.inMeetingLogoURL) {
                return brandingInformation.inMeetingLogoURL;
            } else {
                return '';
            }
        }

        function getBrandingBackgroundUrl() {
            if (brandingInformation && brandingInformation.backgroundURL) {
                return brandingInformation.backgroundURL;
            } else {
                return '';
            }
        }

        function getEchoDetectionEnabled() {
            return echoDetectionFeatureEnabled;
        }

        function getHostNotificationCulture() {
            return hostNotificationCulture;
        }

        function setHostNotificationCulture(notificationCulture) {
            hostNotificationCulture = notificationCulture;
        }

        function initPhone(info) {
            phoneNumber = info.phoneNumberFree || info.phoneNumberToll;
            attendeePIN = info.attendeePIN;
            presenterPIN = info.presenterPIN;
        }

        function openExternalLink(strUrl, strWindowName) {
            if (strUrl === 'base_url_not_available') {
                if (helperService.isMobile() === true) {
                    helperService.mobileAlert('Support article is temporarily unavailable');
                } else {
                    if (helperService.getIsRedesign() === true) {
                        var closeButtonHtml =
                            '<button class="sweetalert-close-x" onclick="window.swal.close();" tabindex="3"><img src="img/redesign/icons/close-big.svg"></img></button>';
                        $window.swal({
                            title:
                                closeButtonHtml + localizationService.translate('DIALOG.SUPPORT_ARTICLE_UNAVAILABLE'),
                            showCancelButton: false,
                            showConfirmButton: true,
                            confirmButtonText: localizationService.translate('COMMON.OK_TEXT'),
                            confirmButtonColor: brandingService.getBaseColor(),
                            closeOnConfirm: true,
                            allowOutsideClick: false,
                            html: true,
                            imageUrl: 'img/redesign/modal/pop-up-pic-warning.svg'
                        });
                    } else {
                        //TODO: REMOVE POST-REDESIGN
                        $window.swal({
                            title: 'Support article is temporarily unavailable',
                            type: 'warning',
                            showCancelButton: false,
                            showConfirmButton: true,
                            confirmButtonText: 'Ok',
                            confirmButtonColor: brandingService.getBaseColor(),
                            closeOnConfirm: true,
                            allowOutsideClick: false,
                            html: true
                        });
                    }
                }
                return;
            }

            if (helperService.isMobile() === true) {
                var mobileConfirmMessage = 'You are about to open a link.\n\nAre you sure you want to do that?',
                    mobileConfirmTitle = 'Confirm Navigation';

                helperService.mobileConfirm(mobileConfirmMessage, mobileConfirmTitle, function (buttonIndex) {
                    // 1 if OK
                    if (buttonIndex === 1) {
                        $window.cordova.InAppBrowser.open(strUrl, '_system');
                    }
                });
            } else {
                if (strWindowName) {
                    $window.open(strUrl, strWindowName);
                } else {
                    $window.open(strUrl, '_blank');
                }
            }
        }

        function setPreventRerouting(preventReroutingToThankYouPage) {
            preventRerouting = preventReroutingToThankYouPage;
        }

        function redirectAfterMeeting(strUrl) {
            if (helperService.isMobile() === true) {
                $window.cordova.InAppBrowser.open(strUrl, '_system');
                service.endMeeting();
            } else {
                if (helperService.isElectron()) {
                    $window.open(strUrl, '_blank');
                    $window.location.href =
                        helperService.getLocationProtocol() +
                        '://www.' +
                        helperService.getLocationHost() +
                        '/AccountManager/';
                } else {
                    $rootScope.$broadcast('removeOnBeforeUnloadConfirmation');
                    $window.location.href = strUrl;
                }
            }
        }

        function endMeeting(options) {
            helperService.setIsMeetingEnding(true);

            //Other ctrls can listen to this event to run cleanup logic
            $rootScope.$broadcast('meeting-ending');

            if (helperService.browserHasWebRTC()) {
                $rootScope.$broadcast('hang-up-verto', { closeFSSocket: true });
                $rootScope.$broadcast('destroy-pip-peer');
            }

            //If a modal is open while we update the route,
            //The modal cannot completely close in time,
            //resulting in the modal backdrop being visible after the route change
            var modalBackdrop = $window.$('.modal-backdrop');
            if (modalBackdrop && modalBackdrop.remove) {
                modalBackdrop.remove();
            }

            if (options && options.kicked) {
                routerService.setStateForKicked(options);
            } else if (options && options.reason) {
                routerService.setEndMeetingState(options);
            } else if (!preventRerouting) {
                routerService.setEndMeetingState();
            }

            if (helperService.isVideoRoomApplication()) {
                $window.preloadedApi.sendEndMeeting();
                return;
            }

            if ($window.cordova) {
                $window.cordova.plugins.backgroundMode.disable();
                if (helperService.getDevicePlatform() === 'iOS') {
                    $window.cordova.plugins.iosrtc.freeCamera();
                }
            }
        }

        function disconnectKickedAttendeeFromMeeting(options) {
            if (!options) {
                options = {};
            }
            options.kicked = true;
            service.endMeeting(options);
        }

        function getCurrentMeeting() {
            return meeting;
        }

        function getDate() {
            return date;
        }

        function getStartTime() {
            return startTime;
        }

        function getEndTime() {
            return endTime;
        }

        function getUpcomingEventTimes() {
            return upcomingEventTimes;
        }

        function setTitle(newTitle) {
            //TODO: Consolidate so that we don't have
            //standalone vars for meeting properties
            title = newTitle;

            if (meeting) {
                meeting.title = newTitle;
            }
        }

        function getTitle() {
            return title;
        }

        function getMeetingCode() {
            return meetingCode;
        }

        function getMeetingServer() {
            return meetingServer;
        }

        function getTimeZone() {
            return timeZone;
        }

        function getTimeZoneId() {
            return timeZoneId;
        }

        function getMaxUsers() {
            return maxUsers;
        }

        function setE2EEMaxUsers(newE2EEMaxUsers) {
            e2eeMaxUsers = newE2EEMaxUsers;
        }

        function getE2EEMaxUsers() {
            return e2eeMaxUsers;
        }

        // extracted in meeting.service.ts
        function isMeeting() {
            return service.getMeetingTypeID() === service.meetingTypes.STANDARD;
        }

        // extracted in meeting.service.ts
        function getMeetingType() {
            return meetingTypeName;
        }

        // extracted in meeting.service.ts
        function getLocalizedMeetingType() {
            return localizedMeetingType;
        }

        // extracted in meeting.service.ts
        function isWebinar() {
            return service.getMeetingTypeID() === service.meetingTypes.WEBINAR;
        }

        function isWebinarAttendeeListAllowed() {
            return service.getMaxUsers() < 500;
        }

        function isAttendeeListVisibleToAttendees() {
            return isWebinarAttendeeListAllowed() && webinarOptions.showAttendeeList;
        }

        function onOnAirModeUpdated(e, data) {
            isOnAir = data && data.isOnAir ? true : false;

            if (isOnAir) {
                analyticsWrapperService.eventTrack('Meeting - Webinar - On-Air Success');
            }
        }

        function setIsOnAir(newOnAirStatus) {
            isOnAir = newOnAirStatus ? true : false;
        }

        function getIsOnAir() {
            return isOnAir;
        }

        function onWebinarOptionsUpdated(e, data) {
            var newWebinarOptions = data && data.webinarOptions ? data.webinarOptions : {};
            if (JSON.stringify(newWebinarOptions) !== JSON.stringify(webinarOptions)) {
                service.setWebinarOptions(newWebinarOptions);
            }
        }

        function getWebinarOptions() {
            return webinarOptions;
        }

        function setWebinarOptions(newWebinarOptions) {
            if (newWebinarOptions && Object.keys(newWebinarOptions).length > 0) {
                webinarOptions.showAttendeeList = newWebinarOptions.showAttendeeList ? true : false;
                webinarOptions.showPublicChat = newWebinarOptions.showPublicChat ? true : false;
                webinarOptions.privateChatOnly = newWebinarOptions.privateChatOnly ? true : false;
                webinarOptions.enableChimes = newWebinarOptions.enableChimes ? true : false;
                webinarOptions.lockWebinar = newWebinarOptions.lockWebinar ? true : false;
                webinarOptions.showReactionsAnimation = newWebinarOptions.showReactionsAnimation ? true : false;

                logService.log('Updated webinar options in meetingService');
            }
        }

        function getExitUrl() {
            return exitUrl;
        }

        function getRequiresPassword() {
            return requiresPassword;
        }

        function setJoinAudioMuted(newVal) {
            if (!joinAudioMutedInitialized) {
                joinAudioMutedInitialized = true;
            }

            joinAudioMuted = newVal;
        }

        function isJoinAudioMutedInitialized() {
            return joinAudioMutedInitialized;
        }

        function getJoinAudioMuted() {
            return joinAudioMuted;
        }

        function onJoinAudioMutedUpdated(e, data) {
            joinAudioMuted = data.joinAudioMuted;
            $rootScope.$broadcast('update-local-join-audio-muted');
        }

        function isLockedInitialized() {
            return lockedInitialized;
        }

        function getLocked() {
            return locked;
        }

        function getJoinRequests() {
            return joinRequests;
        }

        function resetJoinRequests() {
            joinRequests = [];
            waitingRoomStateService.joinRequests = [];
        }

        function declineJoinRequest(joinRequest) {
            var msg = {};
            msg.message = 'join-request-declined';
            msg.data = joinRequest;
            msg.callback = function (data) {
                logService.log(
                    'join-request-declined result from meeting server for ' +
                        joinRequest.emailAddress +
                        ' (' +
                        (joinRequest.id || 'pstn') +
                        '): ' +
                        data.result
                );

                if (data.result) {
                    removeJoinRequestFromList(joinRequest);
                }
            };
            socketService.send(msg);
        }

        function acceptJoinRequest(joinRequest) {
            var msg = {};
            msg.message = 'join-request-accepted';
            msg.data = joinRequest;
            msg.callback = function (data) {
                logService.log(
                    'join-request-accepted result from meeting server for ' +
                        joinRequest.emailAddress +
                        ' (' +
                        (joinRequest.id || 'pstn') +
                        '): ' +
                        data.result
                );

                if (data.result) {
                    removeJoinRequestFromList(joinRequest);
                }
            };
            socketService.send(msg);
        }

        function playKnockSoundForHost() {
            var msg = {};
            msg.message = 'play-knock-sound';
            msg.data = {};
            socketService.send(msg);
        }

        function onJoinRequest(e, data) {
            if (data && data.emailAddress) {
                var joinRequestData = buildJoinRequestData(data);
                var existingJoinRequest = findExistingJoinRequest(joinRequestData);
                if (!existingJoinRequest) {
                    var newJoinRequests = joinRequests.slice();
                    newJoinRequests.push(joinRequestData);
                    joinRequests = newJoinRequests;
                    waitingRoomStateService.joinRequests = joinRequests;
                    $rootScope.$broadcast('on-join-requests-update', { added: true, joinRequest: joinRequestData });
                    playKnockSoundForHost();

                    if (data.attendeeName) {
                        analyticsWrapperService.eventTrack('Meeting - New Join Request - Web attendee');
                    } else {
                        analyticsWrapperService.eventTrack('Meeting - New Join Request - PSTN attendee');
                    }
                }
            } else {
                logger.error('onJoinRequest', "join request data doesn't have value", data);
            }
        }

        function onJoinRequestAvatar(e, data) {
            if (data && data.emailAddress) {
                var joinRequestData = buildJoinRequestData(data);
                var existingJoinRequest = findExistingJoinRequest(joinRequestData);
                if (existingJoinRequest && data.imageURL && data.imageURL !== existingJoinRequest.imageURL) {
                    existingJoinRequest.imageURL = data.imageURL;
                    waitingRoomStateService.joinRequests = joinRequests;
                    $rootScope.$broadcast('on-join-request-avatar-update', { joinRequest: existingJoinRequest });
                }
            } else {
                logger.error('onJoinRequestAvatar', "join request avatar data doesn't have value", data);
            }
        }

        function onJoinRequestUpdated(e, data) {
            if (data && data.emailAddress) {
                var joinRequestUpdatedData = buildJoinRequestUpdatedData(data);
                var existingJoinRequest = findExistingJoinRequest(joinRequestUpdatedData);
                if (existingJoinRequest) {
                    if (
                        joinRequestUpdatedData.imageURL &&
                        joinRequestUpdatedData.imageURL !== existingJoinRequest.imageURL
                    ) {
                        existingJoinRequest.imageURL = joinRequestUpdatedData.imageURL;
                    }

                    if (
                        joinRequestUpdatedData.attendeeName &&
                        joinRequestUpdatedData.attendeeName !== existingJoinRequest.attendeeName
                    ) {
                        existingJoinRequest.attendeeName = joinRequestUpdatedData.attendeeName;
                    }

                    if (
                        joinRequestUpdatedData.isTrusted != null &&
                        joinRequestUpdatedData.isTrusted !== existingJoinRequest.isTrusted
                    ) {
                        existingJoinRequest.isTrusted = joinRequestUpdatedData.isTrusted;
                    }

                    if (
                        joinRequestUpdatedData.isExternal != null &&
                        joinRequestUpdatedData.isExternal !== existingJoinRequest.isExternal
                    ) {
                        existingJoinRequest.isExternal = joinRequestUpdatedData.isExternal;
                    }

                    waitingRoomStateService.joinRequests = joinRequests;
                    $rootScope.$broadcast('on-join-request-updated', { joinRequest: existingJoinRequest });
                }
            } else {
                logger.error('onJoinRequestUpdated', "join request updated data doesn't have value", data);
            }
        }

        function onJoinRequestCanceled(e, data) {
            if (data && data.emailAddress) {
                var joinRequestData = buildJoinRequestData(data);
                var existingJoinRequest = findExistingJoinRequest(joinRequestData);
                if (existingJoinRequest) {
                    removeJoinRequestFromList(existingJoinRequest);

                    // close 'send message to waiting room' dialog if there are no join requests
                    if (
                        joinRequests.length === 0 &&
                        $window.$('.sweet-alert.visible > h2').text() ===
                            localizationService.translate(
                                'JOIN_REQUEST_LIST.SEND_MESSAGE_TO_WAITING_ATTENDEES_DIALOG.HEADER'
                            )
                    ) {
                        $window.swal.close();
                    }

                    if (data.attendeeName) {
                        analyticsWrapperService.eventTrack('Meeting - Join Request Cancelled - Web attendee');
                    } else {
                        analyticsWrapperService.eventTrack('Meeting - Join Request Cancelled - PSTN attendee');
                    }
                }
            } else {
                logger.error('onJoinRequestCanceled', "canceled join request data doesn't have value", data);
            }
        }

        function removeJoinRequestFromList(joinRequest) {
            joinRequests = joinRequests.filter(function (x) {
                return x !== joinRequest;
            });
            waitingRoomStateService.joinRequests = joinRequests;
            $rootScope.$broadcast('on-join-requests-update', { added: false, joinRequest: joinRequest });
        }

        function findExistingJoinRequest(data) {
            if (data && data.emailAddress && !isNaN(data.emailAddress)) {
                //PSTN
                return joinRequests.find(function (x) {
                    return x.emailAddress === data.emailAddress;
                });
            } else {
                return joinRequests.find(function (x) {
                    return x.id === data.id;
                });
            }
        }

        function buildJoinRequestData(joinRequest) {
            return {
                id: joinRequest.id,
                emailAddress: joinRequest.emailAddress ? joinRequest.emailAddress.trim().toLowerCase() : '',
                attendeeName: joinRequest.attendeeName || localizationService.translate('COMMON.PHONE_CALLER'),
                imageURL: joinRequest.attendeeName ? joinRequest.imageURL : '/img/redesign/external-contact-40.png',
                isTrusted: joinRequest.isTrusted,
                isExternal: joinRequest.isExternal
            };
        }

        function buildJoinRequestUpdatedData(joinRequest) {
            return {
                id: joinRequest.id,
                emailAddress: joinRequest.emailAddress ? joinRequest.emailAddress.trim().toLowerCase() : '',
                attendeeName: joinRequest.attendeeName || localizationService.translate('COMMON.PHONE_CALLER'),
                imageURL: joinRequest.imageURL || '/img/redesign/external-contact-40.png',
                isTrusted: joinRequest.isTrusted,
                isExternal: joinRequest.isExternal
            };
        }

        /**
         * Update current joinRequests array
         * @param newData {*[]} New list from server
         * @param currentData {*[]} Existing list
         */
        function mergeJoinRequests(newData, currentData) {
            var buildedNewData = (newData || []).map(buildJoinRequestData);
            var currentDataCopy = currentData.slice();

            // add new join requests
            buildedNewData.forEach(function (newRequest) {
                if (!currentData.find(equal(newRequest))) {
                    currentData.push(newRequest);
                }
            });

            // remove accepted/declined join requests
            currentDataCopy.forEach(function (currentRequest) {
                if (!buildedNewData.find(equal(currentRequest))) {
                    currentData.splice(currentData.indexOf(currentRequest), 1);
                }
            });

            function equal(firstRequest) {
                return function (secondRequest) {
                    if (firstRequest.id && secondRequest.id) {
                        return firstRequest.id === secondRequest.id;
                    }

                    return firstRequest.emailAddress === secondRequest.emailAddress;
                };
            }
        }

        function getAllowJoinRequests() {
            return allowJoinRequests;
        }

        function setAllowJoinRequests(newValue) {
            allowJoinRequests = newValue;
            waitingRoomStateService.allowJoinRequests = newValue;
        }

        function shouldShowUnlockNotification() {
            return attendeeService.getIsHost() && shouldShowUnlockMeetingNotification === true;
        }

        function onMeetingLockedUpdated(e, data) {
            locked = data.meetingLocked;
            shouldShowUnlockMeetingNotification = data.shouldShowUnlockMeetingNotification;

            if (locked) {
                mergeJoinRequests(data.joinRequests, joinRequests);
            } else {
                joinRequests = [];
            }
            waitingRoomStateService.joinRequests = joinRequests;

            $rootScope.$broadcast('update-local-meeting-locked');
        }

        function onMeetingTitleUpdated(e, data) {
            if (data && data.newMeetingTitle) {
                service.setTitle(data.newMeetingTitle);

                //For other ctrls/services to update title
                //based on meetingService's new value
                $rootScope.$broadcast('update-local-meeting-title');
            }
        }

        function isIntermediaDirectUser() {
            if (helperService.isMobile()) {
                if (helperService.getMobileAppPackageName() === 'com.anymeeting.meetingpro') {
                    return true;
                }
                return false;
            }

            return resellerId === helperService.getResellerIdFromConfig('intermediaDirect');
        }

        function isUnivergeUser() {
            return resellerId === helperService.getResellerIdFromConfig('intermediaUB');
        }

        function isIntermediaPLRUser() {
            if (helperService.getLocationHost().indexOf('gomeet') > -1) {
                return true;
            }

            if (helperService.isMobile()) {
                if (helperService.getMobileAppPackageName() === 'net.serverdata.onlinemeeting') {
                    return true;
                }
                return false;
            }

            return resellerId === helperService.getResellerIdFromConfig('intermediaPLR');
        }

        function setIsWaitingForLockUpdate(newIsWaitingForLockUpdate) {
            isWaitingForLockUpdate = newIsWaitingForLockUpdate;
        }

        function getIsWaitingForLockUpdate() {
            return isWaitingForLockUpdate;
        }

        function setIsSfuEnabled(newSfuEnabled) {
            meetingStateService.sfuEnabled = newSfuEnabled;
        }

        function getIsSfuEnabled() {
            return sfuEnabled;
        }

        function setAudioNacks(newAudioNacks) {
            audioNacks = newAudioNacks;
        }

        function getAudioNacks() {
            return audioNacks;
        }

        function getLayoutLockEnabled() {
            return configService.isLayoutLockAvailable();
        }

        function onVideoRoomPinUpdated(e, data) {
            if (data && data.newPin) {
                configService.getSfuPayload().videoRoomPin = data.newPin;
            }
        }

        function setDeviceSelectionEnabled(newVal) {
            deviceSelectionEnabled = newVal;
        }

        function getDeviceSelectionEnabled() {
            //Allow query param to override deviceSelectionEnabled flag
            if (helperService.getQueryParameter('deviceSelection') === 'false') {
                return false;
            }

            return (
                !helperService.isVideoRoomApplication() &&
                service.getIsSfuEnabled() &&
                (deviceSelectionEnabled || helperService.getQueryParameter('deviceSelection') === 'true')
            );
        }

        function setVerticalJoinFlowEnabled(newVal) {
            verticalJoinFlowEnabled = newVal;
        }

        function getVerticalJoinFlowEnabled() {
            return verticalJoinFlowEnabled;
        }

        function setDefaultOSDeviceEnabled(newVal) {
            defaultOSDeviceEnabled = newVal;
        }

        function getDefaultOSDeviceEnabled() {
            return helperService.isVideoRoomApplication() || defaultOSDeviceEnabled;
        }

        function shouldShowDeviceSelectionPreview() {
            //This query param is used to force audio type, in which case we want to skip device preview
            if (helperService.getQueryParameter('audio')) {
                return false;
            }

            if (helperService.getQueryParameter('deviceSelection') === 'true') {
                return true;
            }

            if (service.getVerticalJoinFlowEnabled()) {
                return (
                    !storageService.get('do-not-show-device-selection-flow') && !service.isDevicePreviewCacheDetected()
                );
            }

            return (
                service.getDeviceSelectionEnabled() &&
                !storageService.get('do-not-show-device-selection-flow') &&
                !service.isDevicePreviewCacheDetected()
            );
        }

        function isDevicePreviewCacheDetected() {
            let cookieName = service.getVerticalJoinFlowEnabled()
                ? 'joinedFromVerticalDevicePreview'
                : 'joinedFromDevicePreview';
            return cookieService.get(cookieName) === service.getMeetingCode();
        }

        function setHasShownDeviceSelectionModal(shown) {
            hasShownDeviceSelectionModal = shown;

            if (service.getVerticalJoinFlowEnabled() && !storageService.get('vertical-join-flow-shown')) {
                storageService.set('vertical-join-flow-shown', true);
            }
        }

        function getHasShownDeviceSelectionModal() {
            return hasShownDeviceSelectionModal;
        }

        function getMeetingReactionsOn() {
            return meetingReactionsOn;
        }

        function setMeetingReactionsOn(isOn) {
            meetingReactionsOn = isOn;
        }

        function getMeetingLockAudioPromptsEnabled() {
            return meetingLockAudioPromptsEnabled;
        }

        function setMeetingLockAudioPromptsEnabled(isEnabled) {
            meetingLockAudioPromptsEnabled = isEnabled;
        }

        function shouldShowCurrentTalker() {
            return !storageService.get('disable-current-talker');
        }

        function setAttendeeFavoritesEnabled(newVal) {
            meetingStateService.attendeeFavoritesEnabled = newVal;
        }

        function getAttendeeFavoritesEnabled() {
            return attendeeFavoritesEnabled;
        }

        function getIsPractice() {
            return !!parentMeetingAccessCode;
        }

        function getParentMeetingAccessCode() {
            return parentMeetingAccessCode;
        }

        function setParentMeetingAccessCode(newParentMeetingAccessCode) {
            parentMeetingAccessCode = newParentMeetingAccessCode;
        }

        function setVirtualBackgroundEnabled(newVal) {
            virtualBackgroundEnabled = newVal;
        }

        function getVirtualBackgroundEnabled() {
            if (service.isWebinar()) {
                return service.getIsWebinarVirtualBlurredBackgroundAvailable();
            }
            return true;
        }

        function setEnableAutoPerformanceMode(newVal) {
            enableAutoPerformanceMode = newVal;
        }

        function getEnableAutoPerformanceMode() {
            return enableAutoPerformanceMode && helperService.isUniteApplication();
        }

        function getCompactModeAvailableForRestyling() {
            return helperService.getVDIRef()?.supportCompactMode;
        }

        function getCompactModeAvailable() {
            return (
                helperService.getVDIRef()?.supportCompactMode &&
                ((helperService.isUniteApplication() && helperService.isUniteSupportFeature('compactModeCompatible')) ||
                    helperService.getQueryParameter('compactModeInBrowser') === 'true')
            );
        }

        function setEnableOracleLiveChat(newVal) {
            enableOracleLiveChat = newVal;
        }

        function getEnableOracleLiveChat() {
            return enableOracleLiveChat;
        }

        function setEnableMarqueeButtonHide(newVal) {
            enableMarqueeButtonHide = newVal;
        }

        function getEnableMarqueeButtonHide() {
            return enableMarqueeButtonHide;
        }

        function setEnableCopyFirepadText(newVal) {
            enableCopyFirepadText = newVal;
        }

        function getEnableCopyFirepadText() {
            return enableCopyFirepadText;
        }

        function isTitleBarAvailable() {
            return helperService.isUniteApplication() && helperService.isUniteSupportFeature('titleBarCompatible');
        }

        function canUseMeetingChat() {
            if (service.isWebinar()) {
                return true;
            }

            var securitySettings = service.getMeetingSecuritySettings();
            return !!(securitySettings && securitySettings.canUseMeetingChat) && !service.e2eeEnabled();
        }

        function canUseMeetingNotes() {
            return service.getMeetingSecuritySettings().canUseMeetingNotes && !service.e2eeEnabled();
        }

        function setIsWebinarVirtualBlurredBackgroundAvailable(value) {
            isWebinarVirtualBlurredBackgroundAvailable = value;
        }

        function getIsWebinarVirtualBlurredBackgroundAvailable() {
            return isWebinarVirtualBlurredBackgroundAvailable;
        }

        function getDenoiseValue() {
            return denoiseValue;
        }

        function setDenoiseValue(value) {
            denoiseValue = value;
        }

        function getAutoVolumeAdjustment() {
            return autoVolumeAdjustment;
        }

        function setAutoVolumeAdjustment(value) {
            autoVolumeAdjustment = value;
        }

        function getEchoDetectionState() {
            return echoDetectionEnabled;
        }

        function setEchoDetectionState(value) {
            echoDetectionEnabled = value;
        }

        function getAutoEchoDetectionState() {
            return autoEchoDetectionEnabled;
        }

        function setAutoEchoDetectionState(value) {
            autoEchoDetectionEnabled = value;
        }

        function getMeetingCryptoKeySaltValue() {
            return meetingCryptoKeySalt;
        }

        function setMeetingCryptoKeySaltValue(value) {
            meetingCryptoKeySalt = value;
            meetingStateService.meetingCryptoKeySalt = value;
            $rootScope.$broadcast('e2ee-state-updated');
        }

        function canUseMeetingPrivateChat() {
            return (
                service.getMeetingPrivateChatEnabled() && service.getMeetingSecuritySettings().canUseMeetingPrivateChat
            );
        }

        function getMeetingPrivateChatEnabled() {
            return meetingPrivateChatEnabled;
        }

        function setMeetingPrivateChatEnabled(value) {
            meetingPrivateChatEnabled = value;
        }

        function e2eeEnabled() {
            return !!meetingCryptoKeySalt;
        }

        function getE2EEAvailable() {
            return e2eeAvailable;
        }

        function setE2EEAvailable(value) {
            e2eeAvailable = value;
        }

        function getE2EEEstablished() {
            return e2eeEstablished;
        }

        function setE2EEEstablished(value) {
            e2eeEstablished = value;
        }

        function setNotesRecipients(value) {
            notesRecipients = value;
        }

        function getNotesRecipients() {
            return notesRecipients;
        }

        function getMeetingTypeID() {
            return meetingTypeID;
        }

        function setEnableAudioDisconnect(value) {
            enableAudioDisconnect = value;
        }

        function getEnableAudioDisconnect() {
            return enableAudioDisconnect;
        }

        function onScopeDestroyed() {
            subscriptionService.endSubscription(rootSubscription);
        }

        function getJoinBeforeHostEnabled() {
            return joinBeforeHostEnabled;
        }

        function setJoinBeforeHostEnabled(value) {
            joinBeforeHostEnabled = value;
        }

        function getRecordScreenshareOnly() {
            return recordScreenshareOnly;
        }

        function setRecordScreenshareOnly(value) {
            recordScreenshareOnly = value;
        }

        function getHasQualityBars() {
            return hasQualityBars;
        }

        function setHasQualityBars(value) {
            hasQualityBars = value;
            meetingStateService.qualityBarsEnabled = value;
        }

        //#region AngularSubscriptions

        function initSubscriptions() {
            rootSubscription = subscriptionService.createSubscription();
            subscribeToState();
            subscribeToCalculatedProperties();
        }

        function subscribeToState() {
            rootSubscription.add(
                meetingStateService.sfuEnabled$.subscribe(next => {
                    sfuEnabled = next;
                })
            );

            rootSubscription.add(
                meetingStateService.attendeeFavoritesEnabled$.subscribe(next => {
                    attendeeFavoritesEnabled = next;
                })
            );

            rootSubscription.add(
                meetingStateService.meetingTypeId$.subscribe(next => {
                    meetingTypeID = next;
                })
            );

            rootSubscription.add(
                meetingStateService.maxUsers$.subscribe(next => {
                    maxUsers = next;
                })
            );

            rootSubscription.add(
                meetingStateService.meetingSecuritySettings$.subscribe(next => {
                    meetingSecuritySettings = next;
                })
            );
        }

        function subscribeToCalculatedProperties() {
            rootSubscription.add(
                meetingStateService.meetingTypeName$.subscribe(next => {
                    meetingTypeName = next;
                })
            );

            rootSubscription.add(
                meetingUpgradedService.localizedMeetingType$.subscribe(next => {
                    localizedMeetingType = next;
                })
            );
        }

        //#endregion
    }
]);
